import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import {
  isFieldWrong,
  isFormValid
} from "../../common/lib/validationAllFields";
import {
  addNotificationsForInvalidFields,
  focusInvalidField
} from "../lib/validationWeb";
import Table from "./table.react";

export default class Orders extends Component {
  static propTypes = {
    msg: React.PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {
      actions,
      notificationSystem,
      orders: { orders: { meta: ordersMeta, sort: ordersSort } }
    } = this.props;
    actions.getOrders(ordersMeta, ordersSort).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      }
    });
  }

  render() {
    return (
      <div className="islogged-page">
        <div className="row">
          <div className="col-xs-12">
            <div className="box-wrapper">
              <div className="title">Wszystkie zamówienia</div>
              <div className="content-wrapper">
                <Table {...this.props} tableWidth={1000} tableHeight={300} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/orders/orders.react.js